import { loadImg, roundRect, text, drawBackground, drawBrand, drawCta, drawHeart } from "@/lib/badgeImage";

const drawPhoto = (ctx, img, x, y, w, h, rot) => {
  ctx.save();
  ctx.translate(x + w / 2, y + h / 2); ctx.rotate(rot); ctx.translate(-(x + w / 2), -(y + h / 2));
  ctx.shadowColor = "rgba(131,24,67,0.45)"; ctx.shadowBlur = 60; ctx.shadowOffsetY = 24;
  roundRect(ctx, x - 18, y - 18, w + 36, h + 36, 44); ctx.fillStyle = "#fff"; ctx.fill();
  ctx.shadowColor = "transparent";
  roundRect(ctx, x, y, w, h, 30); ctx.clip();
  const s = Math.max(w / img.width, h / img.height), iw = img.width * s, ih = img.height * s;
  ctx.drawImage(img, x + (w - iw) / 2, y + (h - ih) * 0.35, iw, ih);
  ctx.restore();
};

// simplified phone with the app feed
const drawPhone = (ctx, logo, x, y, w, rot) => {
  const h = w * 1.72, r = w * 0.14, p = w * 0.045;
  ctx.save();
  ctx.translate(x + w / 2, y + h / 2); ctx.rotate(rot); ctx.translate(-(x + w / 2), -(y + h / 2));
  ctx.shadowColor = "rgba(30,10,30,0.45)"; ctx.shadowBlur = 70; ctx.shadowOffsetY = 30;
  roundRect(ctx, x, y, w, h, r); ctx.fillStyle = "#1E1B1D"; ctx.fill(); ctx.shadowColor = "transparent";
  const sx = x + p, sy = y + p, sw = w - p * 2, sh = h - p * 2;
  ctx.save(); roundRect(ctx, sx, sy, sw, sh, r * 0.8); ctx.clip();
  ctx.fillStyle = "#FFF5F8"; ctx.fillRect(sx, sy, sw, sh);
  const u = sw / 100;
  ctx.fillStyle = "#fff"; ctx.fillRect(sx, sy, sw, 16 * u);
  if (logo) ctx.drawImage(logo, sx + 5 * u, sy + 5 * u, 8 * u, 8 * u);
  text(ctx, "itzPlay", sx + 15 * u, sy + 11.5 * u, { size: 5.5 * u, weight: 800, color: "#E11D48", align: "left" });
  roundRect(ctx, sx + 66 * u, sy + 5 * u, 29 * u, 7.5 * u, 3.75 * u); ctx.fillStyle = "#FEF3C7"; ctx.fill();
  text(ctx, "🪙 1.240", sx + 80.5 * u, sy + 10.4 * u, { size: 4 * u, weight: 800, color: "#B45309" });
  const g = ctx.createLinearGradient(sx, 0, sx + sw, 0); g.addColorStop(0, "#F43F5E"); g.addColorStop(1, "#D946EF");
  roundRect(ctx, sx + 5 * u, sy + 21 * u, 90 * u, 24 * u, 5 * u); ctx.fillStyle = g; ctx.fill();
  text(ctx, "NÄCHSTES GESCHENK", sx + 10 * u, sy + 29 * u, { size: 3.4 * u, weight: 800, color: "rgba(255,255,255,0.85)", align: "left" });
  text(ctx, "Signierte Autogrammkarte", sx + 10 * u, sy + 36 * u, { size: 4.6 * u, weight: 800, align: "left", maxW: 80 * u });
  roundRect(ctx, sx + 10 * u, sy + 39.5 * u, 80 * u, 2 * u, u); ctx.fillStyle = "rgba(255,255,255,0.35)"; ctx.fill();
  roundRect(ctx, sx + 10 * u, sy + 39.5 * u, 58 * u, 2 * u, u); ctx.fillStyle = "#fff"; ctx.fill();
  const cards = [["Lena", "Unser Treffen war mega! 💕", "#FB7185"], ["Tom", "+50 Punkte beim Rubbellos 🎟️", "#A78BFA"], ["Mia", "Mein Geschenk ist da! 🎁", "#F59E0B"]];
  cards.forEach(([n, t, c], i) => {
    const cy = sy + (51 + i * 26) * u;
    roundRect(ctx, sx + 5 * u, cy, 90 * u, 22 * u, 5 * u); ctx.fillStyle = "#fff"; ctx.fill();
    ctx.beginPath(); ctx.arc(sx + 13 * u, cy + 8 * u, 4.5 * u, 0, Math.PI * 2); ctx.fillStyle = c; ctx.fill();
    text(ctx, n[0], sx + 13 * u, cy + 9.6 * u, { size: 4.4 * u, weight: 800 });
    text(ctx, n, sx + 20 * u, cy + 9.4 * u, { size: 4.2 * u, weight: 800, color: "#1E1B1D", align: "left" });
    text(ctx, t, sx + 9 * u, cy + 17.5 * u, { size: 3.8 * u, weight: 600, color: "#475569", align: "left", maxW: 82 * u });
  });
  ctx.restore(); ctx.restore();
};

const L = {
  story: { W: 1080, H: 1920, logoY: 140, head: [W2 => W2 / 2, 300, 88], sub: 375, photo: [80, 470, 640, 820, -0.05], phone: [600, 960, 380, 0.07], cta: [1640, 230] },
  square: { W: 1080, H: 1080, logoY: 80, head: [W2 => W2 / 2, 190, 64], sub: 245, photo: [70, 300, 520, 520, -0.05], phone: [640, 290, 270, 0.06], cta: [880, 160] },
};

export async function renderPhotoPromo(format) {
  const P = L[format], { W, H } = P;
  const c = document.createElement("canvas"); c.width = W; c.height = H;
  const ctx = c.getContext("2d");
  await document.fonts?.ready;
  const [photo, logo] = await Promise.all([loadImg("/itzcouple-family.jpg"), loadImg("/logo-mark.png")]);
  drawBackground(ctx, W, H);
  await drawBrand(ctx, W, P.logoY, format === "story" ? 1.2 : 1);
  text(ctx, "Werde Teil unserer Familie!", P.head[0](W), P.head[1], { size: P.head[2], weight: 800, maxW: W - 100, fit: true });
  text(ctx, "Videos schauen · Punkte sammeln · Geschenke gewinnen", W / 2, P.sub, { size: format === "story" ? 38 : 32, weight: 600, font: "Plus Jakarta Sans", color: "rgba(255,255,255,0.92)", maxW: W - 120, fit: true });
  if (photo) drawPhoto(ctx, photo, ...P.photo);
  drawPhone(ctx, logo, ...P.phone);
  drawHeart(ctx, P.photo[0] + 40, P.photo[1] + P.photo[3] - 10, format === "story" ? 120 : 90, "#fff", -0.3);
  drawHeart(ctx, P.photo[0] + 44, P.photo[1] + P.photo[3] + 2, format === "story" ? 90 : 66, "#F43F5E", -0.3);
  await drawCta(ctx, W, P.cta[0], P.cta[1], { code: "", title: "Kostenlos mitmachen bei itzPlay" });
  return new Promise((resolve) => c.toBlob((b) => resolve(b), "image/png"));
}
